<div class="voxtral-section voxtral-live-data">

  <!-- Auto-subtitle bracketing banners (newest on top, faded grey) -->
  <div *ngIf="voxtralSystemMessages.length > 0" class="voxtral-system-section">
    <div *ngFor="let m of voxtralSystemMessages" class="voxtral-system-line">
      <span class="voxtral-system-badge">KI-UT [{{ m.kind }}]</span>
      <span class="voxtral-system-text">{{ m.text }}</span>
    </div>
  </div>

  <!-- Current (growing partial segments) -->
  <div *ngIf="voxtralCurrentText" class="voxtral-current-section">
    <h5 class="voxtral-subtitle">Aktuell</h5>
    <div class="voxtral-partial">
      <span *ngFor="let spk of speakerSequence(voxtralCurrentSpeaker)"
            class="voxtral-speaker-chip" [ngClass]="speakerClass(spk)" [title]="speakerTitle(spk)">{{ speakerLabel(spk) }}</span>
      <span [innerHTML]="voxtralCurrentHtml"></span>
    </div>
  </div>

  <!-- Transcript (confirmed segments, newest on top) -->
  <div *ngIf="voxtralTranscriptLines.length > 0" class="voxtral-transcript-section">
    <h5 class="voxtral-subtitle">Transkript</h5>
    <div class="voxtral-lines">
      <div *ngFor="let html of voxtralTranscriptHtml; let i = index" class="voxtral-line">
        <span *ngFor="let spk of speakerSequence(voxtralTranscriptSpeakers[i])"
              class="voxtral-speaker-chip" [ngClass]="speakerClass(spk)" [title]="speakerTitle(spk)">{{ speakerLabel(spk) }}</span>
        <span [innerHTML]="html"></span>
      </div>
    </div>
  </div>

  <!-- Recent corrections (admin panel) -->
  <div *ngIf="voxtralRecentCorrections.length > 0" class="voxtral-corrections-section">
    <h5 class="voxtral-subtitle voxtral-subtitle-toggle" role="button" [attr.aria-expanded]="voxtralRecentCorrectionsExpanded" (click)="voxtralRecentCorrectionsExpanded = !voxtralRecentCorrectionsExpanded">
      Korrekturen ({{ voxtralRecentCorrections.length }})
      <cds-icon shape="angle" [attr.direction]="voxtralRecentCorrectionsExpanded ? 'down' : 'right'" size="14"></cds-icon>
    </h5>
    <div class="voxtral-corrections-list" *ngIf="voxtralRecentCorrectionsExpanded">
      <div *ngFor="let c of voxtralRecentCorrections; trackBy: trackByCorrectionTs" class="voxtral-correction-row">
        <span class="voxtral-correction-original">{{ c.original }}</span>
        <span class="voxtral-correction-arrow">→</span>
        <span class="voxtral-correction-corrected">{{ c.corrected }}</span>
        <span class="voxtral-correction-scope">{{ c.scope }}</span>
        <button type="button" class="voxtral-blocklist-btn" (click)="addToBlocklist(c.original)" title="Zu Blocklist hinzufügen">×</button>
      </div>
    </div>
  </div>

  <!-- Gate rejections (Phase 4 observability): corrections blocked by the
       morphology gate / blocklist / wordlist. Per-row `stage` chip shows
       which engine produced the candidate. -->
  <div *ngIf="voxtralRecentRejections.length > 0" class="voxtral-corrections-section">
    <h5 class="voxtral-subtitle voxtral-subtitle-toggle" role="button" [attr.aria-expanded]="voxtralRecentRejectionsExpanded" (click)="voxtralRecentRejectionsExpanded = !voxtralRecentRejectionsExpanded">
      Blockiert ({{ voxtralRecentRejections.length }})
      <cds-icon shape="angle" [attr.direction]="voxtralRecentRejectionsExpanded ? 'down' : 'right'" size="14"></cds-icon>
    </h5>
    <div class="voxtral-corrections-list" *ngIf="voxtralRecentRejectionsExpanded">
      <div *ngFor="let r of voxtralRecentRejections; trackBy: trackByCorrectionTs" class="voxtral-correction-row">
        <span class="label voxtral-stage-chip voxtral-stage-chip-inline voxtral-stage-fuzzy">
          {{ correctionStageLabel(r.stage) }}
        </span>
        <span class="voxtral-correction-original">{{ r.original }}</span>
        <span class="voxtral-correction-arrow">⊘</span>
        <span class="voxtral-correction-corrected">{{ r.candidate }}</span>
        <span class="voxtral-correction-scope">{{ r.reason }}</span>
        <span class="voxtral-duration-chip" *ngIf="r.duration_ms > 0">{{ r.duration_ms }} ms</span>
      </div>
    </div>
  </div>

  <!-- Korrektur-API: raw snapshot of GET /api/sessions/{id}/corrections
       fetched from the Voxtral host via the C# proxy. Useful when the WS
       stream looks empty and the operator wants to confirm what the backend
       has actually buffered, plus quick links to the raw endpoints. -->
  <div *ngIf="voxtralSessionApiBase" class="voxtral-segments-section">
    <h5 class="voxtral-subtitle voxtral-subtitle-toggle" role="button" [attr.aria-expanded]="voxtralCorrectionApiExpanded" (click)="voxtralCorrectionApiExpanded = !voxtralCorrectionApiExpanded">
      Korrektur-API ({{ voxtralCorrectionApiTotal }})
      <span *ngIf="voxtralCorrectionApiSnapshot.httpStatus === 'error'" class="label label-danger voxtral-api-error-chip" [title]="voxtralCorrectionApiSnapshot.httpError">Fehler</span>
      <cds-icon shape="angle" [attr.direction]="voxtralCorrectionApiExpanded ? 'down' : 'right'" size="14"></cds-icon>
    </h5>
    <div *ngIf="voxtralCorrectionApiExpanded" class="voxtral-segments-container">
      <div class="voxtral-segments-filter voxtral-segments-filter-spread">
        <span>
          Live von <code class="voxtral-code">/api/sessions/&lt;id&gt;/corrections</code>
          (zuletzt {{ voxtralCorrectionApiSnapshot.fetchedAt | date:'HH:mm:ss' }})
        </span>
        <span>
          <a [href]="voxtralSessionApiBase + '/corrections?limit=200'" target="_blank" rel="noopener" class="voxtral-raw-link">
            Roh-JSON ↗
          </a>
        </span>
      </div>
      <div class="voxtral-segments-list">
        <div *ngIf="voxtralCorrectionApiSnapshot.applied.length === 0 &&
                    voxtralCorrectionApiSnapshot.rejected.length === 0"
             class="voxtral-segment-row voxtral-row-muted">
          <em>Keine Korrekturen — der Server hat noch nichts gepuffert.</em>
        </div>
        <div *ngFor="let c of voxtralCorrectionApiSnapshot.applied"
             class="voxtral-segment-row voxtral-correction-row-two-line">
          <span class="voxtral-stage-chip" [ngClass]="'voxtral-stage-' + (c.stage || 'fuzzy')">{{ correctionStageLabel(c.stage) }}</span>
          <span class="voxtral-segment-ts">{{ c.ts | date:'HH:mm:ss' }}</span>
          <div class="voxtral-seg-pair">
            <div class="voxtral-seg-diff" [innerHTML]="correctionSegmentHtml(c)"></div>
            <div class="voxtral-seg-meta">
              <span class="voxtral-correction-scope" *ngIf="c.scope">{{ c.scope }}</span>
              <span class="voxtral-duration-chip" *ngIf="c.duration_ms && c.duration_ms > 0">{{ c.duration_ms }} ms</span>
            </div>
          </div>
        </div>
        <div *ngFor="let r of voxtralCorrectionApiSnapshot.rejected" class="voxtral-segment-row">
          <span class="voxtral-stage-chip voxtral-stage-fuzzy">{{ correctionStageLabel(r.stage) }}</span>
          <span class="voxtral-segment-ts">{{ r.ts | date:'HH:mm:ss' }}</span>
          <span class="voxtral-correction-original">{{ r.original }}</span>
          <span class="voxtral-correction-arrow">⊘</span>
          <span class="voxtral-correction-corrected">{{ r.candidate }}</span>
          <span class="voxtral-correction-scope" [title]="r.reason">{{ r.reason }}</span>
        </div>
      </div>
    </div>
  </div>

  <div *ngIf="voxtralSegmentTimeline.length > 0" class="voxtral-segments-section">
    <h5 class="voxtral-subtitle voxtral-subtitle-toggle" role="button" [attr.aria-expanded]="voxtralSegmentTimelineExpanded" (click)="voxtralSegmentTimelineExpanded = !voxtralSegmentTimelineExpanded">
      Segmente Zeitachse ({{ voxtralSegmentTimeline.length }})
      <cds-icon shape="angle" [attr.direction]="voxtralSegmentTimelineExpanded ? 'down' : 'right'" size="14"></cds-icon>
    </h5>
    <div *ngIf="voxtralSegmentTimelineExpanded" class="voxtral-segments-container">
      <div class="voxtral-segments-filter">
        <label>
          <input type="radio" name="segScope" [value]="'all'" [ngModel]="voxtralSegmentScopeFilter" (ngModelChange)="onScopeFilterChange($event)"> Alle
        </label>
        <label>
          <input type="radio" name="segScope" [value]="'final'" [ngModel]="voxtralSegmentScopeFilter" (ngModelChange)="onScopeFilterChange($event)"> Final
        </label>
        <label>
          <input type="radio" name="segScope" [value]="'partial'" [ngModel]="voxtralSegmentScopeFilter" (ngModelChange)="onScopeFilterChange($event)"> Partial
        </label>
      </div>
      <div class="voxtral-segments-list">
        <div *ngFor="let s of voxtralFilteredSegments; trackBy: trackBySegmentSeq" class="voxtral-segment-row" [ngClass]="rowSpeakerClass(s)">
          <div class="voxtral-segment-header" (click)="s.expanded = !s.expanded">
            <span class="voxtral-segment-ts">{{ s.ts | date:'HH:mm:ss.SSS' }}</span>
            <span class="voxtral-segment-scope" [class.is-final]="s.scope === 'final'">{{ s.scope === 'final' ? 'F' : 'P' }}</span>
            <span *ngFor="let spk of speakerSequence(s.speaker)"
                  class="voxtral-speaker-chip" [ngClass]="speakerClass(spk)" [title]="speakerTitle(spk)">{{ speakerLabel(spk) }}</span>
            <span class="voxtral-segment-text">{{ s.text }}</span>
            <span class="voxtral-segment-badges">
              <span *ngIf="s.accepted.length > 0" class="voxtral-segment-badge badge-accepted" title="Angewendete Korrekturen">✓ {{ s.accepted.length }}</span>
              <span *ngIf="s.rejected.length > 0" class="voxtral-segment-badge badge-rejected" title="Blockierte Kandidaten">⊘ {{ s.rejected.length }}</span>
              <!-- Frontend #1 — count of prior partials that built this segment -->
              <span *ngIf="(s.partials?.length ?? 0) > 0" class="voxtral-segment-badge"
                    title="Teilversionen, aus denen dieses Segment gewachsen ist (Topic C)">
                ⎘ {{ s.partials!.length }}
              </span>
            </span>
          </div>
          <div *ngIf="s.expanded && (s.accepted.length > 0 || s.rejected.length > 0 || (s.partials?.length ?? 0) > 0 || (s.speaker?.turns?.length ?? 0) > 1)" class="voxtral-segment-body">
            <!-- 2026-09-28 — who said what inside a multi-speaker segment -->
            <div *ngIf="(s.speaker?.turns?.length ?? 0) > 1" class="voxtral-segment-sublist">
              <strong>Sprecherwechsel:</strong>
              <span *ngFor="let run of splitTurns(s.text, s.speaker)" class="voxtral-segment-sub-row voxtral-speaker-run">
                <span class="voxtral-speaker-chip" [ngClass]="speakerClass(run.speaker)" [title]="speakerTitle(run.speaker)">{{ speakerLabel(run.speaker) }}</span>
                {{ run.text }}
              </span>
            </div>
            <!-- Frontend #1 — growing-partial history of this segment -->
            <div *ngIf="(s.partials?.length ?? 0) > 0" class="voxtral-segment-sublist">
              <strong>Teilversionen ({{ s.partials!.length }}):</strong>
              <span *ngFor="let p of s.partials" class="voxtral-segment-sub-row voxtral-partial-row">
                ⎘ {{ p }}
              </span>
            </div>
            <div *ngIf="s.accepted.length > 0" class="voxtral-segment-sublist">
              <strong>Angewendet:</strong>
              <span *ngFor="let a of s.accepted" class="voxtral-segment-sub-row">
                {{ a.original }} → <span class="voxtral-correction-corrected">{{ a.corrected }}</span>;
              </span>
            </div>
            <div *ngIf="s.rejected.length > 0" class="voxtral-segment-sublist">
              <strong>Blockiert:</strong>
              <span *ngFor="let r of s.rejected" class="voxtral-segment-sub-row">
                {{ r.original }} ⊘ {{ r.candidate }} <em>({{ r.reason }})</em>;
              </span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

</div>
